import _auth from '_functions/auth'

const checkLogin = async () => {
    const user = await _auth.viewing_user();
    if(!user.data) {
        return window.location.href = `/login/?redirect=${window.location.pathname}`
    }
}

export default checkLogin;